var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThemeModeDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C9.62663 0 7.30655 0.703788 5.33316 2.02237C3.35977 3.34094 1.8217 5.21509 0.913451 7.4078C0.00519935 9.60051 -0.232441 12.0133 0.230582 14.3411C0.693605 16.6689 1.83649 18.8071 3.51472 20.4853C5.19295 22.1635 7.33115 23.3064 9.65892 23.7694C11.9867 24.2324 14.3995 23.9948 16.5922 23.0866C18.7849 22.1783 20.6591 20.6402 21.9776 18.6668C23.2962 16.6935 24 14.3734 24 12C24 11.3867 23.9467 10.7733 23.8667 10.1867C23.2004 11.1209 22.3202 11.8819 21.2995 12.4062C20.2788 12.9305 19.1474 13.2026 18 13.2C16.4736 13.2 14.9867 12.7152 13.7536 11.8155C12.5205 10.9158 11.6051 9.64775 11.1394 8.19414C10.6736 6.74054 10.6816 5.17657 11.1622 3.72781C11.6428 2.27905 12.5711 1.02037 13.8133 0.133333C13.2267 0.0533332 12.6133 0 12 0Z",
    fill: "#C6C7C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemeModeDark);
export default __webpack_public_path__ + "static/media/theme-mode-dark.30c3034025639b6cefb6782ef0eeffcd.svg";
export { ForwardRef as ReactComponent };